/* NO WASTE — ventana de bienvenida (descuento primera compra). */
(() => {
  const popup = document.querySelector('[data-nw-popup]');
  if (!popup) return;
  const tab = document.querySelector('[data-nw-popup-open]');
  const KEY = 'nw-popup-closed';
  const DAYS = 14;
  const store = {
    get() { try { return Number(localStorage.getItem(KEY)) || 0; } catch (e) { return 0; } },
    set() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} },
  };
  const recentlyClosed = () => Date.now() - store.get() < DAYS * 864e5;

  const open = () => {
    popup.hidden = false;
    setTimeout(() => popup.classList.add('is-open'), 30);
    if (tab) tab.hidden = true;
    const first = popup.querySelector('input[type=email], .nw-popup__code, .nw-popup__close');
    setTimeout(() => first && first.focus({ preventScroll: true }), 300);
  };
  const close = () => {
    popup.classList.remove('is-open');
    setTimeout(() => (popup.hidden = true), 400);
    store.set();
    if (tab && !popup.classList.contains('is-done')) tab.hidden = false;
  };

  popup.addEventListener('click', (e) => { if (e.target.closest('[data-nw-popup-close]')) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !popup.hidden) close(); });
  if (tab) tab.addEventListener('click', open);

  // Shopify marca como enviado cualquier formulario de cliente de la página: si el envío
  // fue la activación profesional (no el popup), no mostrar el 5 % ni aplicar el código.
  if (popup.classList.contains('is-done') && location.hash === '#NwProActivate') {
    popup.classList.remove('is-done', 'is-open');
    popup.hidden = true;
    return;
  }

  // Suscrito: aplicar el código al carrito y permitir copiarlo
  if (popup.classList.contains('is-done')) {
    const code = popup.dataset.code;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: code }) }).catch(() => {});
    store.set();
    const copy = popup.querySelector('[data-nw-copy]');
    if (copy) copy.addEventListener('click', () => {
      navigator.clipboard && navigator.clipboard.writeText(code).then(() => { copy.querySelector('span').textContent = 'Copiado'; });
    });
    return;
  }

  if (recentlyClosed()) { if (tab) tab.hidden = false; return; }

  // Esperar a que acabe la intro de la portada y a que la persona muestre interés
  const introWait = document.documentElement.classList.contains('nw-intro-run') ? 2500 : 0;
  let shown = false;
  const trigger = () => { if (!shown) { shown = true; open(); } };
  setTimeout(trigger, (Number(popup.dataset.delay) || 12) * 1000 + introWait);
  window.addEventListener('scroll', function onScroll() {
    const h = document.documentElement;
    if ((h.scrollTop + innerHeight) / h.scrollHeight > 0.55) { window.removeEventListener('scroll', onScroll); setTimeout(trigger, 600); }
  }, { passive: true });
})();
